export default {
  routes: {
    '/': require('../views/Wiki'),
    '/quickStart': require('../views/QuickStart'),
    '/mac': require('../views/Mac'),
    '/mvvm': require('../views/Mvvm'),
  }
}



// WEBPACK FOOTER //
// ./src/config/router.js